import { render, staticRenderFns } from "./RequestGivePoints.vue?vue&type=template&id=43328edd&scoped=true&"
import script from "./RequestGivePoints.vue?vue&type=script&lang=js&"
export * from "./RequestGivePoints.vue?vue&type=script&lang=js&"
import style0 from "./RequestGivePoints.vue?vue&type=style&index=0&id=43328edd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43328edd",
  null
  
)

export default component.exports